import { convertLength } from "@Utils";
import { useState } from "react";

interface IUseActivitySearchProps {
  distance: number;
  distanceGlobal: number;
}

const DEFAULT_TOGGLE_OPTIONS = {
  checkedChildren: "Imperial",
  unCheckedChildren: "Metric",
  className: "with-gradient",
};

const useActivitySearch = ({
  distance: metricDistance,
  distanceGlobal: metricDistanceGlobal,
}: IUseActivitySearchProps) => {
  const [isDistanceGraphImperial, setIsDistanceGraphImperial] = useState(false);

  const distance = isDistanceGraphImperial ? convertLength(metricDistance, "metres", "yards") : metricDistance;
  const distanceGlobal = isDistanceGraphImperial
    ? convertLength(metricDistanceGlobal, "metres", "yards")
    : metricDistanceGlobal;

  const suffix = isDistanceGraphImperial ? "yd" : "m";

  const distanceGraphOptions = {
    target: distanceGlobal,
    imperial: isDistanceGraphImperial,
    title: `Distance Travelled (${suffix})`,
    toggleOptions: { ...DEFAULT_TOGGLE_OPTIONS, onClick: () => setIsDistanceGraphImperial(!isDistanceGraphImperial) },
    tooltip: {
      customItems: (originalItems) => {
        const firstItem = {
          ...originalItems[0],
          name: "Your Average",
        };
        const secondItem = {
          ...originalItems[0],
          name: "Global Average",
          color: "#ccc",
          value: distanceGlobal + suffix,
        };
        return [firstItem, secondItem];
      },
      formatter: ({ mKey, ...data }) => {
        const value = data[mKey];
        return { name: "Distance Travelled", value: value + suffix };
      },
    },
    value: distance,
  };

  return {
    distanceGraphOptions,
  };
};

export default useActivitySearch;
